import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { RootState, AppDispatch } from './store'

export const useWHMDispatch = () => useDispatch<AppDispatch>()
export const useWHMSelector: TypedUseSelectorHook<RootState> = useSelector